import React, { useRef, useState ,useEffect} from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import SelectSearchParty from "../AdminSearchExpense/SelectSearchParty";
import { useNavigate } from 'react-router-dom';
import Select from "react-select";
import { Table } from "react-bootstrap";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { ApiUrl } from "../../../ApiUrl";



const AdmAttendanceEntry = () => {
  const todayDate = new Date().toISOString().split("T")[0];
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();
  const [bankOptions, setBankOptions] = useState([]);
  const [selectedBank, setSelectedBank] = useState(null);
  const [paymentOptions, setPaymentOptions] = useState([]);
  const [selectedPayment, setSelectedPayment] = useState(null);
  const [accountOptions, setAccountOptions] = useState([]);
  const [selectedAccount, setSelectedAccount] = useState(null);

  const [searchResults, setSearchResults] = useState([]);

   const [partyDetails, setPartyDetails] = useState({
      party_id: "",
      party_name: "",
      party_type: "",
      gst_no: "",
      city: "",
      state: "",
      address: "",
      phone: "",
      email_id: "",
    });


    const [fromDate, setFromDate] = useState(todayDate);
    const [toDate, setToDate] = useState(todayDate);
    const [partyReference, setPartyReference] = useState("");
    const [incomeDetails, setIncomeDetails] = useState(null);





  const dateRef = useRef(null);
  const fromClassRef = useRef(null);
  const toClassRef = useRef(null);
  const admissionNoRef = useRef(null);
  const barcodeRef = useRef(null);
  const smsToRef = useRef(null);

 
 const handleEdit = async (incomeId) => {
   try {
     const response = await fetch(
       `${ApiUrl.apiurl}EXPENSE/INCOME/IncomeDetailsRetrieve/${incomeId}/`
     );
     const result = await response.json();

     if (response.ok && result.message === "success") {
       console.log("Fetched Income Details:", result.data); // Log API response
       navigate("/admin/addincome", { state: { incomeData: result.data } }); // Navigate with data
     } else {
       console.error("Failed to fetch income details: " + result.message);
     }
   } catch (error) {
     console.error("Error fetching income details:", error);
   }
 };

 const handleView = async (incomeId) => {
   try {
     const response = await fetch(
       `${ApiUrl.apiurl}EXPENSE/INCOME/IncomeDetailsRetrieve/${incomeId}/`
     );
     const result = await response.json();

     if (response.ok && result.message === "success") {
       console.log("Fetched Income Details:", result.data); // Log API response
       navigate("/admin/income-detail", { state: { incomeData: result.data } }); // Navigate with data
     } else {
       console.error("Failed to fetch income details: " + result.message);
     }
   } catch (error) {
     console.error("Error fetching income details:", error);
   }
 };
  useEffect(() => {
    fetch(`${ApiUrl.apiurl}BANK/GetAllbankList/`)
      .then((response) => response.json())
      .then((data) => {
        if (data && data.data) {
          const options = data.data.map((bank) => ({
            value: bank.id,
            label: bank.bankname,
          }));
          setBankOptions(options);
        }
      })
      .catch((error) => {
        console.error("Error fetching bank list:", error);
      });
  }, []);

  useEffect(() => {
    fetch(`${ApiUrl.apiurl}PAYMENTMETHOD/GetAllpaymentmethodList/`)
      .then((response) => response.json())
      .then((data) => {
        if (data && data.data) {
          const options = data.data.map((method) => ({
            value: method.id,
            label: method.paymentmethod,
          }));
          setPaymentOptions(options);
        }
      })
      .catch((error) => {
        console.error("Error fetching payment methods:", error);
      });
  }, []);

  // Fetch Account Numbers based on selected Bank
  useEffect(() => {
    if (selectedBank) {
      fetch(
        `${ApiUrl.apiurl}Account_Details/GetAccountDetailsBasedOnBankId/${selectedBank.value}/`
      )
        .then((response) => response.json())
        .then((data) => {
          if (data && data.data) {
            const options = data.data.map((account) => ({
              value: account.id,
              label: account.bank_account.toString(), // Convert to string to ensure compatibility
            }));
            setAccountOptions(options);
          }
        })
        .catch((error) => {
          console.error("Error fetching account details:", error);
        });
    } else {
      setAccountOptions([]); // Clear account list when no bank is selected
    }
  }, [selectedBank]);

const handleSearch = async () => {
  // Retrieve org_id, branch_id, and academic_year_id from local storage
  const orgId = localStorage.getItem("orgId");
  const branchId = localStorage.getItem("branchId");
  const academicSessionId = localStorage.getItem("academicSessionId");

  // Validate if all required values exist
  if (!orgId || !branchId || !academicSessionId) {
    alert("Missing required data from local storage. Please check.");
    return;
  }

  // Construct query parameters dynamically based on user inputs
  const queryParams = new URLSearchParams({
    org_id: orgId,
    branch_id: branchId,
    academic_year_id: academicSessionId,
  });

  // Append additional filters if they have values
  if (partyDetails.party_id)
    queryParams.append("party_id", partyDetails.party_id);
  if (fromDate) queryParams.append("from_date", fromDate);
  if (toDate) queryParams.append("to_date", toDate);
  if (selectedPayment?.label)
    queryParams.append("payment_method", selectedPayment.label);
  if (selectedBank?.value) queryParams.append("bankId", selectedBank.value);
  if (selectedAccount?.value)
    queryParams.append("accountId", selectedAccount.value);
  if (partyReference) queryParams.append("party_reference", partyReference);

  try {
    const response = await fetch(
      `${
        ApiUrl.apiurl
      }EXPENSE/INCOME/IncomeSearchList/?${queryParams.toString()}`
    );

    const data = await response.json();

    if (data.message === "success") {
      setSearchResults(data.data); // Store the filtered API response in state
    } else {
      console.error("Failed to fetch income search results:", data.message);
      setSearchResults([]); // Reset the search results on failure
    }
  } catch (error) {
    console.error("Error fetching income search results:", error);
    setSearchResults([]); // Reset the search results on error
  }
};



  const handleOpenModal = () => {
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handleNewClick = () => {
    navigate("/admin/addincome");
  };


   const handleSelectedParty = (selectedParty) => {
     console.log("Selected Party:", selectedParty);

     setPartyDetails({
       party_id: selectedParty.party_id || "",
       party_name: selectedParty.party_name || "",
       party_type: selectedParty.party_type || "",
       gst_no: selectedParty.gst_no || "",
       city: selectedParty.city || "",
       state: selectedParty.state || "",
       address: selectedParty.address || "",
       phone: selectedParty.phone || "",
       email_id: selectedParty.email_id || "",
     });

     handleCloseModal();
   };


const handleExportToExcel = () => {
  if (searchResults.length === 0) {
    alert("No data to export!");
    return;
  }

  // Define the table headers
  const headers = [
    [
      "Income ID",
      "Income No",
      "Date",
      "Party Name",
      "Payment Method",
      "Bank Name",
      "Account No",
      "Amount",
    ],
  ];

  // Map searchResults into a format suitable for Excel
  const data = searchResults.map((income) => [
    income.income_id,
    income.income_no,
    income.income_date,
    income.partyName,
    income.payment_method,
    income.bankName || "N/A",
    income.account_name ? income.account_name : "N/A",
    income.amount.toFixed(2),
  ]);

  // Calculate total amount
  const totalAmount = searchResults
    .reduce((sum, income) => sum + income.amount, 0)
    .toFixed(2);

  // Add total row
  data.push(["", "", "", "", "", "", "Total:", totalAmount]);

  // Create a worksheet
  const ws = XLSX.utils.aoa_to_sheet([...headers, ...data]);

  // Create a workbook and append the worksheet
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Income Data");

  // Export the Excel file
  XLSX.writeFile(wb, "Income_Data.xlsx");
};


const handleExportToPDF = () => {
  if (searchResults.length === 0) {
    alert("No data to export!");
    return;
  }

  const doc = new jsPDF();

  // Set logo path
  const logoPath = "/SynergyLogo.gif"; // Relative path inside public folder

  // Add college name
  doc.setFontSize(16);
  doc.text("Synergy College", 80, 20); // Adjust position as needed

  // Add logo
  const img = new Image();
  img.src = logoPath;
  img.onload = () => {
    doc.addImage(img, "PNG", 15, 10, 30, 20); // X, Y, Width, Height

    // Define table headers
    const headers = [
      [
        "Income ID",
        "Income No",
        "Date",
        "Party Name",
        "Payment Method",
        "Bank Name",
        "Account No",
        "Amount",
      ],
    ];

    // Map searchResults into a format suitable for PDF
    const data = searchResults.map((income) => [
      income.income_id,
      income.income_no,
      income.income_date,
      income.partyName,
      income.payment_method,
      income.bankName || "N/A",
      income.account_name ? income.account_name : "N/A",
      income.amount.toFixed(2),
    ]);

    // Calculate total amount
    const totalAmount = searchResults
      .reduce((sum, income) => sum + income.amount, 0)
      .toFixed(2);

    // Add total row
    data.push(["", "", "", "", "", "", "Total:", totalAmount]);

    // Generate table
    doc.autoTable({
      startY: 40, // Adjust based on logo position
      head: headers,
      body: data,
      theme: "grid",
    });

    // Save the PDF
    doc.save("Income_Data.pdf");
  };
};

const handleClear = () => {
  setSelectedPayment(null);
  setSelectedBank(null);
  setSelectedAccount(null);
  setPartyDetails({
    party_id: "",
    party_name: "",
    party_type: "",
    gst_no: "",
    city: "",
    state: "",
    address: "",
    phone: "",
    email_id: "",
  });
  setFromDate(todayDate);
  setToDate(todayDate);
  setPartyReference("");
  setSearchResults([]); // Clear table data
};


  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-12">
          <div className="card p-0">
            <div className="card-body">
              <p
                style={{
                  marginBottom: "0px",
                  textAlign: "center",
                  fontSize: "20px",
                  fontWeight: "700",
                }}
              >
                SEARCH INCOME
              </p>
              <div className="row mb-3 mt-3 mx-0">
                <div className="col-12  d-flex flex-wrap gap-2">
                  <button
                    type="button"
                    className="btn btn-primary me-2"
                    style={{
                      width: "150px",
                    }}
                    onClick={handleNewClick}
                  >
                    New Income
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary me-2"
                    style={{
                      width: "150px",
                    }}
                    onClick={handleSearch}
                  >
                    Search
                  </button>
                  <button
                    type="button"
                    className="btn btn-secondary me-2"
                    style={{
                      width: "150px",
                    }}
                    onClick={handleClear}
                  >
                    Clear
                  </button>
                  <button
                    type="button"
                    className="btn btn-danger me-2"
                    style={{
                      width: "150px",
                    }}
                    onClick={() => navigate("/admin/dashboard")}
                  >
                    Close
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary me-2"
                    style={{
                      width: "150px",
                    }}
                    onClick={handleExportToPDF}
                  >
                    Export to PDF
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary me-2"
                    style={{
                      width: "150px",
                    }}
                    onClick={handleExportToExcel}
                  >
                    Export to Excel
                  </button>
                </div>
              </div>

              <div className="row mt-3 mx-2">
                <div className="col-12 custom-section-box">
                  <div className="d-flex flex-column flex-md-row align-items-start align-items-md-center">
                    <div className="row flex-grow-1">
                      <div className="col-12 col-md-3 mb-1">
                        <label htmlFor="party-name" className="form-label">
                          Party Name
                        </label>
                        <div className="d-flex align-items-center">
                          <input
                            type="text"
                            id="party-name"
                            className="form-control detail"
                            placeholder="Enter party name"
                            ref={admissionNoRef}
                            value={partyDetails.party_name}
                            disabled
                          />
                          <button
                            type="button"
                            className="btn btn-primary ms-2 mb-3 mt-0"
                            onClick={handleOpenModal}
                            style={{ width: "50px", padding: "3px" }}
                          >
                            ...
                          </button>
                        </div>
                      </div>

                      <SelectSearchParty
                        show={showModal}
                        handleClose={handleCloseModal}
                        onSelect={handleSelectedParty}
                      />

                      <div className="col-12 col-md-3 mb-1">
                        <label htmlFor="from-date" className="form-label">
                          From Date
                        </label>
                        <input
                          type="date"
                          id="from-date"
                          className="form-control detail"
                          value={fromDate}
                          onChange={(e) => setFromDate(e.target.value)}
                        />
                      </div>
                      <div className="col-12 col-md-3 mb-1">
                        <label htmlFor="To-date" className="form-label">
                          To Date
                        </label>
                        <input
                          type="date"
                          id="to-date"
                          className="form-control detail"
                          value={toDate}
                          onChange={(e) => setToDate(e.target.value)}
                        />
                      </div>

                      <div className="col-12 col-md-3 mb-2">
                        <label htmlFor=" payment-method" className="form-label">
                          Payment Method
                        </label>
                        <Select
                          id="payment-method"
                          classNamePrefix="payment-select"
                          className="detail"
                          options={paymentOptions}
                          value={selectedPayment}
                          onChange={(selectedOption) => {
                            setSelectedPayment(selectedOption);
                            if (selectedOption?.label === "BANK") {
                              setSelectedBank(null); // Clear bank selection when switching
                            }
                          }}
                          placeholder="Select payment method"
                        />
                      </div>

                      <div className="col-12 col-md-3 mb-3">
                        <label htmlFor=" Bank" className="form-label">
                          Bank
                        </label>
                        <Select
                          id="bank"
                          classNamePrefix="bank-select"
                          className="detail"
                          options={bankOptions}
                          value={selectedBank}
                          onChange={setSelectedBank}
                          placeholder="Select bank"
                          isDisabled={selectedPayment?.label !== "BANK"} // Enable only if "BANK" is selected
                        />
                      </div>

                      <div className="col-12 col-md-3 mb-2">
                        <label htmlFor=" account-no" className="form-label">
                          Account No
                        </label>
                        <Select
                          id="account-no"
                          classNamePrefix="account-select"
                          className="detail"
                          options={accountOptions}
                          value={selectedAccount}
                          onChange={setSelectedAccount}
                          placeholder="Select Account No"
                          isDisabled={!selectedBank}
                        />
                      </div>

                      <div className="col-12 col-md-3 mb-1">
                        <label htmlFor="party-reference" className="form-label">
                          Party Reference
                        </label>
                        <div className="d-flex align-items-center">
                          <input
                            type="text"
                            id="party-reference"
                            className="form-control detail"
                            placeholder="Enter party reference"
                            value={partyReference}
                            onChange={(e) => setPartyReference(e.target.value)}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-12">
                {searchResults.length > 0 && (
                  <div className="table-responsive">
                    <table className="table">
                      <thead className="thead-dark">
                        <tr>
                          <th>Income ID</th>
                          <th>Income No</th>
                          <th>Date</th>
                          <th>Party Name</th> 
                          <th>Party Reference</th>
                          <th>Payment Method</th>
                          <th>Bank Name</th>
                          <th>Account No</th>
                          <th>Amount</th>
                          <th>View</th>
                          <th>Edit</th>
                        </tr>
                      </thead>
                      <tbody>
                        {searchResults.map((income) => (
                          <tr key={income.income_id}>
                            <td>{income.income_id}</td>
                            <td>{income.income_no}</td>
                            <td>{income.income_date}</td>
                            <td>{income.partyName}</td>
                            <td>{income.party_reference || income.partyReference || "N/A"}</td>
                            <td>{income.payment_method}</td>
                            <td>{income.bankName || "N/A"}</td>
                            <td>
                              {income.account_name
                                ? income.account_name
                                : "N/A"}
                            </td>
                            <td>{income.amount.toFixed(2)}</td>
                            <td>
                              <a
                                href="#"
                                className="text-primary"
                                onClick={(e) => {
                                  e.preventDefault(); // Prevent default anchor behavior
                                  handleView(income.income_id); // Call handleEdit with income ID
                                }}
                              >
                                View
                              </a>
                            </td>
                            <td>
                              <a
                                href="#"
                                className="text-primary"
                                onClick={(e) => {
                                  e.preventDefault(); // Prevent default anchor behavior
                                  handleEdit(income.income_id); // Call handleEdit with income ID
                                }}
                              >
                                Edit
                              </a>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                      {/* Add Total Row */}
                      <tfoot>
                        <tr>
                          <td colSpan="8" className="text-end fw-bold">
                            Total:
                          </td>
                          <td className="fw-bold">
                            {searchResults
                              .reduce((sum, income) => sum + income.amount, 0)
                              .toFixed(2)}
                          </td>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                )}
              </div>

              {/* End of Total, Paid, Balance row */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdmAttendanceEntry;
